import { Navigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { EmployeePerformancePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import Page from 'modules/layout/components/Page'
import PageLoading from 'modules/layout/components/Page/Loading'
import TargetProcessesOverviewTable from 'modules/performance_v2/components/TargetProcessesOverviewTable'
import EmployeesCollectionsBootstrap from 'modules/performance_v2/lib/EmployeesCollectionsBootstrap'

type RootPage = 'employee' | 'profile'
type Props = {
  rootPage: RootPage
}

const EmployeePerformancePage = ({ rootPage }: Props) => {
  const { navigation } = useNavigation()

  const { employee: sessionEmployee } = useCurrentSession()
  const { id: employeeIdparam } = useStrictParams<'id'>()
  const employeeId = employeeIdparam ?? sessionEmployee.id

  const { loading, data } = useQuery(EmployeePerformancePageDocument, {
    variables: { id: employeeId },
  })
  const currentEmployee = data?.employees.employee
  const canSeePerformance = currentEmployee?._policies?.seeEmployeePerformanceTab.can ?? false

  if (loading) {
    return (
      <Box width="full" height="full" justifyContent="center" alignItems="center">
        <PageLoading />
      </Box>
    )
  }

  const navigateBack: Record<RootPage, string> = {
    employee: navigation.employees.id.fullPath({ id: employeeId }),
    profile: navigation.profile.fullPath(),
  }

  if (!canSeePerformance) return <Navigate replace to={navigateBack[rootPage]} />

  return (
    <EmployeesCollectionsBootstrap>
      <Page.Body>
        {currentEmployee && <TargetProcessesOverviewTable accessId={currentEmployee?.access.id} />}
      </Page.Body>
    </EmployeesCollectionsBootstrap>
  )
}

export default EmployeePerformancePage
